export const MIN_FONT_SIZE = 5;
export const MAX_FONT_SIZE = 30;

export const clampFontSize = (value) => {
  const numericValue = Number(value);
  if (!Number.isFinite(numericValue)) return MIN_FONT_SIZE;
  return Math.min(Math.max(numericValue, MIN_FONT_SIZE), MAX_FONT_SIZE);
};
